import http from "./http_common"
import {DEPERDITION_Mur} from '../../../app/routes'



export const stepMur = (data:any) => {
  return  http.post("/deperdition/mur", data)
};